import LeadsDragContainers from './LeadsDragContainers.component';

export default LeadsDragContainers;